import { render, staticRenderFns } from "./districtPicker.vue?vue&type=template&id=352db5de&"
import script from "./districtPicker.vue?vue&type=script&lang=ts&"
export * from "./districtPicker.vue?vue&type=script&lang=ts&"
import style0 from "./districtPicker.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports